import { doc, getFirestore, setDoc } from "firebase/firestore";
import { Vacation, VacationStatus } from "../types/Vacation";
import { Employee } from "../types/Employee";
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from "luxon";

export const createVacationRequest = async (employee: Employee, startDate: string, endDate: string) => {
  try {
    const vacation: Vacation = {
      id: uuidv4(),
      idNumber: employee.idNumber,
      name: employee.name,
      status: "Requested",
      requestDateStart: startDate,
      requestDateEnd: endDate,
      requestStatus: 'New',
      dateStart: startDate,
      dateEnd: endDate,
      dateRequested: DateTime.utc().toISO(),
      lastUpdate: DateTime.utc().toISO(),
    };
    const db = getFirestore();
    await setDoc(doc(db, `Employees/${vacation.idNumber}/Vacations/${vacation.id}`), vacation);
    return true;
  } catch {
    return false;
  }
};